import { jsxs, jsx } from 'react/jsx-runtime';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-pill.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSTriggerPill = props => {
  const {
    active,
    children,
    className,
    disabled,
    icon,
    id,
    name,
    onClick,
    selected,
    toggleState,
    domRef
  } = props;
  const baseClassName = 'uitk-pill';
  const buttonClassName = getClassNameList(`${baseClassName} ${baseClassName}-content`, className, {
    [`${baseClassName}-trigger-toggle-state`]: toggleState,
    [`${baseClassName}-active`]: active,
    [`${baseClassName}-disabled`]: disabled,
    [`${baseClassName}-selected`]: selected
  });
  return jsxs("button", {
    id: id,
    name: name,
    type: "button",
    onClick: onClick,
    disabled: disabled,
    className: buttonClassName,
    "aria-expanded": toggleState,
    ref: domRef,
    children: [icon && jsx(EGDSIcon, {
      className: getClassNameList(`${baseClassName}-icon`),
      name: icon
    }), jsx("span", {
      className: getClassNameList(`${baseClassName}-text`),
      children: children
    }), jsx(EGDSIcon, {
      name: "expand_more",
      className: getClassNameList(`${baseClassName}-trigger-icon`)
    })]
  });
};
EGDSTriggerPill.displayName = 'EGDSTriggerPill';
export { EGDSTriggerPill };